module.exports = __webpack_public_path__ + "static/Odgazowywacz_termiczny-3900628d056654362b38c525deacd1ec.png";